<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="page lead-page mt-4" v-else-if="loaded" >
        
        <b-input-group class="mb-3" >
            <b-form-input v-model="filter" placeholder="Type to Search" class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>

        <div class="col-12 events font-size-14"  >

            <div >
                <b-tabs pills card vertical nav-wrapper-class="col-3 border-left-gray border-right-gray" >
                    
                    <b-tab v-for="(event, index) in matches" v-bind:key="event.id" >
                        <template v-slot:title >
                            <span class="timeline-bullet timeline-bullet-left" ></span>
                            <div style="position: absolute; right:10px;" >
                                <b-badge v-if="event.action_status == 'SUCCESS'"  variant="success">SUCCESS</b-badge>
                                <b-badge v-if="event.action_status == 'FAIL'"  variant="danger">Failed</b-badge>
                            </div>
                            <p class="mb-2 font-800" > 
                                {{event.action}} {{event.type}}
                                <span v-if="event.type == 'CONVERSION'" >
                                    - 
                                    <b-badge v-if="event.orderStatus == 'completed'"  variant="success">{{event.orderStatus}}</b-badge>
                                    <b-badge v-if="event.orderStatus == 'processing'"  variant="secondary">{{event.orderStatus}}</b-badge>
                                    <b-badge v-if="event.orderStatus == 'refunded'"  variant="danger">{{event.orderStatus}}</b-badge>
                                </span>
                            </p>
                            <p class="mb-0 graymedium-color " > 
                                {{ formatDate(event) }}    
                                <span v-if="adminRole == 0" style="position: absolute; right:10px;" @click="preventDelete(event)" > <font-awesome-icon icon="trash-alt" />  </span>
                            </p>
                        </template>
                        <p class="pl-3 pr-3" style="overflow: auto; max-height: 540px;" >
                            
                            <vue-json-pretty
                              :path="'res'"
                              :data="event"
                              >
                            </vue-json-pretty>
                            
                        </p>
                    </b-tab>

                </b-tabs>
            </div>

        </div>
    </div>

</template>

<script>
    
import clicksComponent from '../../components/clicks.vue' 
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
import helper from '@/helpers/helpers.js';
    
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';

export default{
    name: "LeadEvents",
    components:{
        clicksComponent,
        VueJsonPretty
    },
    props: {
        ID: { 
            type: [Number, String],
        },
    },
    data () {
        return {
            filter: '',
            rows: [],
            loaded: false,
            LEAD: {},
            adminRole: null,
            
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        this.get_data();
        //this.test_mailchimp();
        
        this.adminRole = helper.getAdminLevel()
    },
    computed: {
    },
    methods: {
        
        test_mailchimp(){
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8'}
            
            axios({ method: 'POST', url: 'http://localhost:8080/integrations/mailchimp/test', headers: headers, data: "" })
                .then(resp => {
                
                console.log(resp) 
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        get_data(){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = firebase.firestore();
            //var ref = db.collection('organizations/'+orgID+'/leads/'+this.ID+'/clicks');
            //var ref = db.collection('organizations/'+orgID+'/events').where('IP_SALT', 'in', this.LEAD.IP_ARRAY );
            var ref = db.collection('organizations/'+orgID+'/events').where('leadID', '==', this.ID )

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                
                                const ordered = {};
                                Object.keys(item).sort().forEach(function(key) {
                                  ordered[key] = item[key];
                                });
                                
                                results.push( ordered )
                                
                                results.sort((a, b) => b.datetime - a.datetime);
                                this.rows = results
                            
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results; 
                        this.loaded = true;
                    })

                })
            
        },
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'HH:mm:ss MMM D, YYYY' )
            return helper.formatDate( a.datetime, 'HH:mm:ss MMM D, YYYY' )
        },
        preventDelete( item ){
            
            //console.log(item)
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.deleteEvent(item);
                    
                }
            })
            
        },
        deleteEvent( item ){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let eventID = item.id
            let leadID = this.ID
            
            const db = firebase.firestore();
            db.collection('organizations/'+orgID+'/events').doc( eventID ).delete()
            .then(async function(){
                
                await db.collection('organizations/'+orgID+'/leads/'+leadID+'/clicks').where( 'eventID', '==', eventID ).get()
                .then(async (results)=>{
                    results.forEach(async(click)=>{
                        //console.log( click.data() )
                        //console.log( click.id )
                        await db.collection('organizations/'+orgID+'/leads/'+leadID+'/clicks').doc( click.id ).delete()
                    })
                })
                
                this.rows = this.rows.filter(row => row.id != item.id );
                
            }.bind(this))
            
        },
    },
    computed:{
        getOrganizationID(){
            return this.$store.getters.getOrganizationID
        },
        matches() {
            return this.filter
                ? this.rows.filter(row => {
                  let match = false
                  for (let key in row) {
                    if ( row['payload']['referralURL'].toLowerCase().includes(this.filter.toLowerCase()) || row['payload']['previousURL'].toLowerCase().includes(this.filter.toLowerCase()) ) {
                      return true
                    }
                  }
                })
                : this.rows
        }
    }
}
</script>

<style scoped >
    
    
    
</style>


// WEBPACK FOOTER //
// src/templates/leads/Events.vue